import { formatText } from 'bernie-l10n';
import * as React from 'react';
import { UitkBanner } from 'uitk-react-banner';

interface ErrorBannerProp {
  type: ErrorMessageType;
}

export enum ErrorMessageType {
  SEARCH_ERROR = 'SEARCH_ERROR',
  OFFER_UNAVAILABLE = 'OFFER_UNAVAILABLE',
  BOOKING_ERROR = 'BOOKING_ERROR',
  DEFAULT = 'DEFAULT'
}

export const ErrorBanner: React.FC<ErrorBannerProp> = ({ type }): JSX.Element => {
  const renderErrorBanner = (type: string) => {
    switch (type) {
      case 'SEARCH_ERROR':
        return (
          <div className="all-t-margin-three all-x-margin-three" data-testid="search-error">
            <UitkBanner icon="info_outline" message={formatText('lx.search.errors.searchFailed')} />
          </div>
        );
      case 'OFFER_UNAVAILABLE':
        return (
          <div className="all-t-margin-three all-x-margin-three" data-testid="offer-unavailable-error">
            <UitkBanner icon="warning" message={formatText('lx.search.errors.offers.not.available')} />
          </div>
        );
      case 'BOOKING_ERROR':
        return (
          <div className="all-t-margin-three all-x-margin-three" data-testid="booking-error">
            <UitkBanner icon="warning" message={formatText('lx.activity.booking.error')} />
          </div>
        );
      default:
        return (
          <div className="all-t-margin-three all-x-margin-three" data-testid="default-error">
            Error
          </div>
        );
    }
  };

  return renderErrorBanner(type);
};
